<template>
  <div class="home">
<ComputacionNavar/>
<BannerComputacion/>
<CategoriasComputacion/>
<ComputacionFqa/>
<FooterSection/>
  </div>
</template>

<script>
import ComputacionNavar from '@/components/computacion/ComputacionNavar.vue';
import BannerComputacion from '@/components/computacion/BannerComputacion.vue';
import CategoriasComputacion from '@/components/computacion/CategoriasComputacion.vue';
import ComputacionFqa from '@/components/computacion/ComputacionFqa.vue';
import FooterSection from '@/components/FooterSection.vue';


export default {                                                                                                            
  name: 'TelefonoView',
  components: {
ComputacionNavar,
BannerComputacion,
CategoriasComputacion,
ComputacionFqa,
FooterSection,
  }
}
</script>